import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../../structure/row';
import { Cell, LEFT, RIGHT } from '../../structure/cell';
import { FormattedPrice } from '../../../price/formatted_price';

export function Buy4Pay3(props) {
    return (
        <Row className="sidebar__row--discount discount discount--buy-4-pay-3">
            <Cell side={LEFT}>
                <div className="discount__tag">Discount</div>
                <div className="discount__name">Buy 4, Pay 3</div>
            </Cell>
            <Cell side={RIGHT}></Cell>
            <Cell side={RIGHT}>
                <FormattedPrice
                    price={props.discount}
                    currencyIsoCode={props.currencyIsoCode}
                    className="discount__price"
                    inCents={true}
                />
            </Cell>
        </Row>
    );
}

Buy4Pay3.propTypes = {
    discount: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
